import { initialState } from "./state";

export const Login = (state = initialState, action) => {
  switch (action.type) {
    case "SET_ADMIN_DETAILS": {
      return Object.assign({}, state, {
        AdminDetails: action.data
      });
    }
    default:
      return state;
  }
};
